import objectFitImages from 'object-fit-images';
import picturefill from "picturefill";

export default function packages () {
    objectFitImages();
    picturefill();
}